<template>
  <ToggleSection
    label="Acquisition Details"
    icon-classes="fa-solid fa-microscope"
    :collapsed="!dv.isEditing"
  >
    <FieldGrid
      class="form-fields"
      :fields="[
        ['pixel_size', 'nominal_magnification'],
        ['c2_aperture', 'objective_aperture'],
        ['phase_plate'],
        ['exposure_time', 'electron_dose'],
        ['image_format', 'movie_fraction'],
        ['beam_size', 'spot_size'],
        ['beam_mode', 'energy_filter'],
        ['slit_width', 'montage'],
      ]"
      :dv="dv"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'TransmissionEMDatasetAcquisitionDetails',
  components: {
    ToggleSection,
    FieldGrid,
  },
  props: {
    dv: { type: Object, required: true },
  },
}
</script>
